module.exports = __webpack_public_path__ + "static/media/RessourcesPage2.ad729fd4.svg";